if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.querySelector('.product-media-modal__arrow--next')?.addEventListener('click', (e) => {
          e.stopPropagation();
          this.showNext();
        });
        
        this.querySelector('.product-media-modal__arrow--prev')?.addEventListener('click', (e) => {
          e.stopPropagation();
          this.showPrev();
        });

   
        // Dodaj obsługę klawiatury
        document.addEventListener('keydown', (e) => {
          if (!this.classList.contains('open')) return;
          if (e.key === 'ArrowRight') this.showNext();
          if (e.key === 'ArrowLeft') this.showPrev();
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => element.classList.remove('active'));

        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      // Nowe metody
      showNext() {
        const currentIndex = this.mediaItems.findIndex((el) => el.classList.contains('active'));
        const nextIndex = (currentIndex + 1) % this.mediaItems.length;
        this.setActiveMedia(this.mediaItems[nextIndex]);
      }

      showPrev() {
        const currentIndex = this.mediaItems.findIndex((el) => el.classList.contains('active'));
        const prevIndex = (currentIndex - 1 + this.mediaItems.length) % this.mediaItems.length;
        this.setActiveMedia(this.mediaItems[prevIndex]);
      }

      setActiveMedia(mediaElement) {
        this.mediaItems.forEach((el) => el.classList.remove('active'));
        mediaElement.classList.add('active');
        mediaElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

        const activeMediaTemplate = mediaElement.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          mediaElement.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          mediaElement.loadContent();
        }
      }
    }
  );
}
